import create from "zustand";
import moment from "moment";
import { servicesService } from "../services/servicesService.js";
import { notify } from "../assets/helpers/toast.js";
import { filterParams } from "../assets/helpers/funciones.js";

export const useTvSectionStore = create((set, get) => ({
  sinceDate: new Date(),
  untilDate: new Date(),
  name: "",
  data: {
    data: [],
    isLoading: true,
  },

  setSinceDate: (date) => {
    const { untilDate } = get();
    if (date > untilDate) {
      notify("Ingrese una fecha en un rango válido", "info");
    } else {
      set({ sinceDate: date });
    }
  },

  setUntilDate: (date) => {
    const { sinceDate } = get();
    if (date < sinceDate) {
      notify("Ingrese una fecha en un rango válido", "info");
    } else {
      set({ untilDate: date });
    }
  },

  setName: (value) => set({ name: value ?? "" }),

  setData: (payload) => set({ data: payload }),

  updateProviderCount: ({ _id, totalActive, totalDone }) => {
    const { data, fetchServicesByOperatorTV } = get();
    const currentRows = data?.data ?? [];
    const index = currentRows.findIndex((row) => row._id === _id);
    if (index >= 0) {
      const newRows = currentRows
        .map((row, i) =>
          i === index ? { ...row, totalActive, totalDone } : row
        )
        .sort(
          (a, b) =>
            (b.totalActive ?? 0) +
            (b.totalDone ?? 0) -
            ((a.totalActive ?? 0) + (a.totalDone ?? 0))
        );
      set({ data: { ...data, data: newRows, isLoading: false } });
    } else {
      fetchServicesByOperatorTV();
    }
  },

  fetchServicesByOperatorTV: () => {
    const { sinceDate, untilDate, name } = get();
    set((state) => ({
      data: { ...state.data, isLoading: true },
    }));

    const params = {
      dateFrom: moment(sinceDate).format("YYYY-MM-DD"),
      dateTo: moment(untilDate).format("YYYY-MM-DD"),
      name: name || undefined,
    };

    servicesService
      .getServicesByOperatorTV(filterParams(params))
      .then((response) => {
        if (response.status === 200) {
          set({
            data: {
              data: response?.data ?? [],
              isLoading: false,
            },
          });
        } else {
          notify(response?.message || "Error al cargar datos", "error");
          set((state) => ({
            data: { ...state.data, isLoading: false },
          }));
        }
      })
      .catch(() => {
        notify("Error al cargar datos", "error");
        set((state) => ({
          data: { ...state.data, isLoading: false },
        }));
      });
  },
}));
